/* @flow weak */
import React from 'react';
import Form from 'components/Form.jsx';
import Button from 'components/Button.jsx';
import BoxBody from 'components/BoxBody.jsx';
import FormInput from 'components/FormInput.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import DialogContent from 'components/DialogContent.jsx';
import ToastActions from 'actions/ToastActions';
import DeviceActions from 'actions/DeviceActions';

class LinkSmsPhoneInputBox extends React.Component {
  static propTypes = {
    onDone: React.PropTypes.func.isRequired,
    closable: React.PropTypes.bool,
    footer: React.PropTypes.object,
  };

  state = {
    submitting: false,
  };

  submitPhoneNumber = (form) => {
    const phoneNumber = form['phone_number'];

    const onSuccess = (response) => {
      this.setState({ submitting: false });

      this.props.onDone({
        token: response.token,
        phoneNumber,
      });
    };

    const onError = (response) => {
      this.setState({ submitting: false });

      if (response && response.code === 'duplicate_device') {
        ToastActions.showErrorToast(
          'This device is already linked to your account.'
        );
        return;
      }

      if (response && response.code === 'underage_account_conflict') {
        ToastActions.showErrorToast(
          'Please contact support for assistance linking this device.'
        );
        return;
      }

      if (response && response.code === 'validation_error') {
        const message = response.error.endpoint && response.error.endpoint[0] ||
          'Please enter a valid phone number.';
        ToastActions.showErrorToast(message);
        return;
      }

      ToastActions.showDefaultErrorToast();
    };

    this.setState({ submitting: true });

    DeviceActions
      .outboundVerify(phoneNumber)
      .then(onSuccess, onError);
  };

  render() {
    return (
      <DialogContent
        size="small"
        full
        title={'What is your mobile number?'}
        onRequestHide={this.props.onRequestHide}
        hideCloseButton={!this.props.closable}
        subtext={'We’ll send you a code to connect your phone.'}>
        <BoxBody divided>
          <Form onValidSubmit={this.submitPhoneNumber}>
            <FormInput
              name="phone_number"
              className="LinkSmsPhoneInputBox-Input"
              autofocus
              placeholder="(555) 555-5555"
              size="large"
              type="text"
              validations={{ couldPlausiblyBeANorthAmericanPhoneNumber: true }}
              validationErrors={{
                couldPlausiblyBeANorthAmericanPhoneNumber:
                'Invalid phone number',
              }}
              showErrorAfterBlur
            />

            <Button
              className="LinkSmsPhoneInputBox-Submit"
              disabled={this.state.submitting}
              type="submit"
              eventElementName="LinkSmsPhoneInputBox-Submit">
              Send code
            </Button>
          </Form>
        </BoxBody>
        {
          this.props.footer ?
            <BoxFooter>{this.props.footer}</BoxFooter> : null
        }
      </DialogContent>
    );
  }
}

export default LinkSmsPhoneInputBox;



// WEBPACK FOOTER //
// ./src/user/components/LinkSmsPhoneInputBox.jsx